<template>
	<a-modal
		title="提现"
		:width="520"
		:visible="visible"
		:confirmLoading="loading"
		:maskClosable="false"
		:forceRender="true"
		@ok="handleOk"
		@cancel="() => { $emit('cancel') }"
	>
		<a-form-model ref="form" :model="form" :label-col="{ span: 6 }" :wrapper-col="{ span: 15 }">
			<a-form-model-item
				label="用户"
				prop="userId"
				:rules="[{ required: true, message: '请选择用户', trigger: 'change' }]"
			>
				<a-select
					v-model="form.userId"
					show-search
					placeholder="输入 ID / 账号 / 昵称 搜索"
					:filter-option="false"
					:not-found-content="userFetching ? undefined : null"
					style="width: 100%"
					@search="onUserSearch"
					@change="onUserChange"
				>
					<a-spin v-if="userFetching" slot="notFoundContent" size="small" />
					<a-select-option v-for="item in userList" :key="item.id" :value="item.id">
						{{ userLabel(item) }}
					</a-select-option>
				</a-select>
			</a-form-model-item>
			<a-form-model-item v-if="selectedUser" label="当前余额">
				<span>{{ fmtMoney(selectedUser.balance) }}</span>
			</a-form-model-item>
			<a-form-model-item label="提现金额" prop="cashOutAmount" :rules="amountRules">
				<a-input-number
					v-model="form.cashOutAmount"
					:min="0.01"
					:max="maxAmount"
					:step="1"
					:precision="2"
					style="width: 100%"
					placeholder="请输入提现金额"
				/>
			</a-form-model-item>
		</a-form-model>
	</a-modal>
</template>

<script>
import { userOpts } from '@/api/member/user';
import { fmtMoney } from '@/utils/money';

const amountRules = [
	{ required: true, type: 'number', message: '必填，不能为空', trigger: 'change' },
];

function emptyForm() {
	return {
		userId: undefined,
		cashOutAmount: undefined,
	};
}

export default {
	props: {
		visible: {
			type: Boolean,
			required: true,
		},
		loading: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			form: emptyForm(),
			userList: [],
			selectedUser: null,
			userFetching: false,
			userSearchTimer: null,
			amountRules,
			fmtMoney,
		};
	},
	computed: {
		maxAmount() {
			const balance = Number(this.selectedUser && this.selectedUser.balance);
			if (Number.isNaN(balance) || balance <= 0) {
				return 0.01;
			}
			return balance;
		},
	},
	watch: {
		visible(val) {
			if (val) {
				this.form = emptyForm();
				this.selectedUser = null;
				this.fetchUsers();
				this.$nextTick(() => {
					if (this.$refs.form) {
						this.$refs.form.clearValidate();
					}
				});
			}
		},
	},
	beforeDestroy() {
		if (this.userSearchTimer) {
			clearTimeout(this.userSearchTimer);
		}
	},
	methods: {
		fetchUsers(keyword = '') {
			this.userFetching = true;
			userOpts({ keyword }).then((res) => {
				this.userList = res.data.opts || [];
			}).finally(() => {
				this.userFetching = false;
			});
		},
		onUserSearch(keyword) {
			if (this.userSearchTimer) {
				clearTimeout(this.userSearchTimer);
			}
			this.userSearchTimer = setTimeout(() => {
				this.fetchUsers(keyword);
			}, 300);
		},
		onUserChange(userId) {
			this.selectedUser = this.userList.find((item) => item.id === userId) || null;
		},
		userLabel(item) {
			const name = item.nickname || item.loginAccount;
			return `${name}（ID:${item.id}） 余额:${fmtMoney(item.balance)}`;
		},
		handleOk() {
			if (!this.$refs.form) {
				return;
			}
			this.$refs.form.validate((valid) => {
				if (!valid) {
					return;
				}
				this.$emit('ok', {
					userId: this.form.userId,
					cashOutAmount: this.form.cashOutAmount,
				});
			});
		},
	},
};
</script>
